// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'inventory-manufacturer.page.title': 'Manufacturers',
    'inventory-manufacturer.page.archive.title': 'Archived Manufacturers',
    'inventory-manufacturer.page.search_results': 'Search Results',
    'inventory-manufacturer.page.create.title': 'New Manufacturer',
    'inventory-manufacturer.page.search.title': 'Find Manufacturers',
    'inventory-manufacturer.page.edit.title': 'Edit Manufacturer',
    'inventory-manufacturer.page.all': 'All',

    'inventory-manufacturer.button.cancel': 'Cancel',
    'inventory-manufacturer.button.select': 'Select',
    'inventory-manufacturer.button.find': 'Find Manufacturers',
    'inventory-manufacturer.button.search': 'Apply',
    'inventory-manufacturer.button.create': 'Create Manufacturer',
    'inventory-manufacturer.button.new': 'New Manufacturer',
    'inventory-manufacturer.button.save': 'Save Changes',
    'inventory-manufacturer.button.archive': 'Archive',
    'inventory-manufacturer.button.delete': 'Permanently Delete',
    'inventory-manufacturer.button.edit': 'Edit',
    'inventory-manufacturer.button.restore': 'Restore',
    'inventory-manufacturer.button.reset': 'Reset',

    'inventory-manufacturer.placeholder.search': 'Search Manufacturers',

    'inventory-manufacturer.link.create_first_inventory_manufacturer': 'Click here to create your first manufacturer',
    'inventory-manufacturer.link.inventory_manufacturers': ' Return to Manufacturers',
    'inventory-manufacturer.link.archive': 'Archived Manufacturers',
    'inventory-manufacturer.link.retry': 'Click here to retry',

    'inventory-manufacturer.checkbox.all': 'Check All',
    'inventory-manufacturer.checkbox.actions_label': 'with selected',

    'inventory-manufacturer.label.inventory_manufacturer_name': 'Manufacturer Name',

    'inventory-manufacturer.sort.field_label': 'Field',
    'inventory-manufacturer.sort.direction_label': 'Direction',
    'inventory-manufacturer.sort.direction_ascending': 'Ascending',
    'inventory-manufacturer.sort.direction_descending': 'Descending',

    'inventory-manufacturer.modal.title.inventory_manufacturer_archive': 'Archive Manufacturer',
    'inventory-manufacturer.modal.title.inventory_manufacturer_delete_permanently': 'Delete Manufacturer',
    'inventory-manufacturer.modal.title.inventory_manufacturer_restore': 'Restore Manufacturer',

    'inventory-manufacturer.modal.message.inventory_manufacturer_archive': 'Are you sure that you want to move this manufacturer to the archive? | Are you sure that you want to move these manufacturers to the archive?',
    'inventory-manufacturer.modal.message.inventory_manufacturer_delete_permanently':
        'Are you sure that you want to permanently delete this manufacturer? This action cannot be undone. | Are you sure that you want to permanently delete these manufacturers? This action cannot be undone.',
    'inventory-manufacturer.modal.message.inventory_manufacturer_restore': 'Are you sure that you want to restore this manufacturer? | Are you sure that you want to restore these manufacturers?',

    'inventory-manufacturer.success.message.inventory_manufacturer_created': 'Your manufacturer has been created',
    'inventory-manufacturer.success.message.inventory_manufacturer_updated': 'Your manufacturer has been updated',
    'inventory-manufacturer.success.message.inventory_manufacturer_restored': 'Your manufacturer has been restored | All selected manufacturers were restored',
    'inventory-manufacturer.success.message.inventory_manufacturer_deleted': 'Your manufacturer has been permanently deleted | All selected manufacturers were permanently deleted',
    'inventory-manufacturer.success.message.archived_inventory_manufacturers': 'Your manufacturer was moved to the archive | All selected manufacturers were moved to the archive',

    'inventory-manufacturer.error.message.archived_inventory_manufacturers': 'This manufacturer was already moved to the archive | These manufacturers were already moved to the archive',
    'inventory-manufacturer.error.message.inventory_manufacturer_deleted': 'This manufacturer was already permanently deleted | These manufacturers were already permanently deleted',
    'inventory-manufacturer.error.message.inventory_manufacturer_restored': 'This manufacturer was already restored | These manufacturers were already restored',
    'inventory-manufacturer.error.message.error_loading_page': 'Sorry, there was an error loading manufacturer.| Sorry, there was an error loading manufacturers.',

    'inventory-manufacturer.message.search.no_archived_inventory_manufacturers': "You don't have any archived manufacturers.",
};
